import { useContext, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";

import { Container } from "./LoginStyles";

import AuthContext from "../../context/authentication/authContext";

import InputAuth from "../Forms/InputAuth";
import TitleLogo from "./TitleLogo";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import { HomeWrap } from "../../wrapper";
import { useDispatch, useSelector } from "react-redux";
import { errorAlert } from "../../actions/alerts";
import AlertPopUp from "../generalComponents/AlertPopUp";

const RegisterForm = () => {
  const dispatch = useDispatch();

  const { msgAlert } = useSelector((state) => state.alert);

  const authContext = useContext(AuthContext);
  const { message, authenticated, registerUSer } = authContext;
  //context

  const history = useHistory();

  useEffect(() => {
    if (authenticated) {
      history.push("/creator");
    }

    //eslint-disable-next-line
  }, [message, authenticated, history]);

  const initialValues = {
    name: "",
    email: "",
    password: "",
    confirm: "",
  };

  const registerSchema = Yup.object().shape({
    name: Yup.string().required("Name Required"),
    email: Yup.string().required("Email Required"),
    password: Yup.string()
      .required("Password Required")
      .min(6, "minimun 6 char"),
    confirm: Yup.string().required("Confirm Required"),
  });

  const handleFormikSubmit = (values, actions) => {
    const { confirm, password } = values;

    if (confirm !== password) {
      dispatch(errorAlert(`Passwords does not match`, 400));

      return;
    }

    registerUSer(values);
  };

  return (
    <Container>
      <TitleLogo title="Sign up!" to="to" />

      <Formik
        validationSchema={registerSchema}
        initialValues={initialValues}
        onSubmit={handleFormikSubmit}
      >
        {() => {
          return (
            <div className="form">
              <Form>
                <InputAuth name="name" label="Name" type="text" />
                <InputAuth name="email" label="Email" type="email" />
                <InputAuth name="password" label="Password" type="password" />
                <InputAuth
                  name="confirm"
                  label="Confirm Password"
                  type="password"
                />
                {msgAlert && (
                  <AlertPopUp msg={msgAlert.msg} type={msgAlert.type} />
                )}
                <button className="btn btn-login login__btn" type="submit">
                  Sign in
                </button>
                <div className="login__status">
                  <p>Already a member?</p>
                  <NavLink className="login__status--link" to="/login">
                    Log in
                  </NavLink>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    </Container>
  );
};

export default HomeWrap(RegisterForm);
